import React from 'react';
import { useLanguage } from '../../../i18n/LanguageContext';
import { FaClock } from 'react-icons/fa';

const ComingSoonTemples = () => {
  const { t } = useLanguage();

  const temples = [
    {
      id: 1,
      name: "Kashi Vishwanath Temple",
      location: "Varanasi, Uttar Pradesh",
      description: "One of the most sacred Shiva temples",
      image: "https://plus.unsplash.com/premium_photo-1661963629241-52c812d5c7f8?q=80&w=687&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
    },
    {
      id: 2,
      name: "Jagannath Puri Temple",
      location: "Puri, Odisha",
      description: "Famous for the annual Rath Yatra",
      image: "https://images.unsplash.com/photo-1706790574525-d218c4c52b5c?q=80&w=1470&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
    },
    {
      id: 3,
      name: "Somnath Temple",
      location: "Gujarat",
      description: "First among the twelve Jyotirlingas",
      image: "https://plus.unsplash.com/premium_photo-1691030922124-c6a81c377234?q=80&w=736&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
    }
  ];


  return (
    <section className="py-12 bg-gradient-to-br from-orange-50 to-amber-50">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl font-bold text-orange-800 mb-8 text-center">
          {t('otherSacredTemples')}
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {temples.map((temple) => (
            <div key={temple.id} className="bg-white rounded-xl shadow-lg overflow-hidden relative group hover:shadow-xl transition-all">
              <div className="relative">
                <img 
                  src={temple.image} 
                  alt={temple.name} 
                  className="w-full h-48 object-cover"
                />
                <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center">
                  <span className="bg-gradient-to-r from-orange-500 to-red-500 text-white px-4 py-2 rounded-full font-semibold">
                    <FaClock className="mr-2" />
                    {t('comingSoon')}
                  </span>
                </div>
              </div>
              <div className="p-6 text-center">
                <h3 className="text-xl font-bold text-orange-800 mb-2">{temple.name}</h3>
                <p className="text-gray-600 mb-3">{temple.location}</p>
                <p className="text-sm text-orange-600">{temple.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ComingSoonTemples;
